import styles from '@styles/components/media/cantfindwhatyouarelooking/index.module.scss';
import {useRef} from "react";
import {useInView} from "framer-motion";
import * as React from "react";

export const CantFindWhatYouAreLooking = () => {

    // these variables are used to animate the left and right image when this view are on screen.
    const ref = useRef(null);
    const isInView = useInView(ref, {once: false});

    /**
     * in this section user can download the pdf file of the products.
     */
    return (
        <section className={styles.you_are_looking_for} ref={ref}>
            <div className={`images ${isInView ? 'image_animation' : ''}`}>
                <img className={'desktop'} src="/assets/images/decorations/media/media_cant_find_banner_left.webp"
                     alt="image"/>
                <img className={'desktop'}
                     src="/assets/images/decorations/media/media_cant_find_banner_right.webp"
                     alt="image"/>
                <img className={'ipad'} src="/assets/images/decorations/media/media_cant_find_ipad_left.webp"
                     alt="image"/>
                <img className={'ipad'} src="/assets/images/decorations/media/media_cant_find_ipad_right.webp"
                     alt="image"/>
                <img className={'mobile'}
                     src="/assets/images/decorations/media/media_cant_find_mobile_left.webp" alt="image"/>
                <img className={'mobile'}
                     src="/assets/images/decorations/media/media_cant_find_mobile_right.webp"
                     alt="image"/>
            </div>
            <span>can’t find what you’re looking for?</span>
            <div className={'description'}
                 dangerouslySetInnerHTML={{__html: 'For all media enquiries please email us at <a href="mailto:care@sidr.com">care@sidr.com</a>'}}></div>
        </section>
    )
}
